import { PaginationParams } from 'src/app/core/interfaces/pagination-params.interface';
import { UseCase } from 'src/app/core/utils/usecase';
import { ClaimPagination } from '../entities/claim-pagination.entity';
import { Failure } from 'src/app/core/utils/failure';
import { ClaimsPaginationParams } from '../entities/claim-pagination-params.entity';
import { Injectable } from '@angular/core';
import { ClaimMultiRepositoryBase } from '../repositories/claim-multi-base.repository';
import { MultiPagination } from '../entities/multi-pagination.entity';

@Injectable()
export class GetFinishedMultiUseCase
  implements UseCase<PaginationParams, MultiPagination | Failure>
{
  constructor(private claimRepository: ClaimMultiRepositoryBase) {}

  async execute(
    param: ClaimsPaginationParams
  ): Promise<MultiPagination | Failure> {
    return await this.claimRepository.getAllFinishedClaims(param);
  }
}
